'use client';

import { useEffect } from 'react';

import AuthSessionErrorPanel from '@/components/auth/AuthSessionErrorPanel';
import { RouteFallback } from '@/components/ui/RouteFallback';
import {
  NETWORK_RECOVERY_ERROR_MESSAGE,
  SESSION_VALIDATION_ERROR_MESSAGE,
  getSafeErrorMessage,
} from '@/lib/auth/sessionErrors';

type ErrorPageProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

const ErrorPage = ({ error, reset }: ErrorPageProps) => {
  useEffect(() => {
    console.error(error);
  }, [error]);

  const safeMessage = getSafeErrorMessage(error.message);

  if (safeMessage === SESSION_VALIDATION_ERROR_MESSAGE || safeMessage === NETWORK_RECOVERY_ERROR_MESSAGE) {
    return <AuthSessionErrorPanel description={safeMessage} />;
  }

  return (
    <RouteFallback
      title="Something went wrong"
      description="This page could not be loaded. Try again, or return to SportsFi."
      onRetry={reset}
    />
  );
};

export default ErrorPage;
